import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store"
import config from "@/config"

import auth from "./auth"
import onboard from "./onboard"
import tutorials from "./tutorials"
import designSystem from "./design-system"
import ads from "./ads"
import audiences from "./audiences"
import smartAudiences from "./smart-audiences"
import settings from "./settings"

import RouterView from "@/components/ui/RouterView.vue"
import AuthShell from "@/components/page/auth/Shell.vue"
import OnboardShell from "@/components/page/onboard/Shell.vue"
import HomeShell from "@/components/page/home/Shell.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
  },

  // Auth routes
  {
    path: "",
    component: AuthShell,
    children: auth,
  },

  // Onboard
  {
    path: "/onboard",
    component: OnboardShell,
    children: onboard,
    meta: { requiresAuth: true },
  },

  // Home routes
  {
    path: "",
    component: HomeShell,
    children: [
      {
        path: "/dashboard",
        component: () => import("@/views/dashboard/DashboardIndex.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/audiences",
        component: RouterView,
        // component: () => import("@/components/page/ads/edit/PageLayout.vue"),
        children: audiences,
        meta: { requiresAuth: true },
      },
      {
        path: "/smart-audiences",
        component: RouterView,
        children: smartAudiences,
        meta: { requiresAuth: true },
      },
      {
        path: "/ads",
        component: RouterView,
        children: ads,
        meta: { requiresAuth: true },
      },
      {
        path: "/faq",
        component: () => import("@/views/faq/Index.vue"),
      },
      {
        path: "/tutorials",
        component: RouterView,
        children: tutorials,
        meta: { requiresAuth: true },
      },
      {
        path: "/settings",
        component: () => import("@/components/page/settings/PageLayout.vue"),
        children: settings,
        meta: { requiresAuth: true },
      },

      // Helper routes
      // {
      //   path: "/connect",
      //   component: defineComponent({
      //     name: "ConnectFacebook",
      //     beforeRouteEnter(to, _, next) {
      //       next({
      //         name: "onboard.connect.facebook",
      //         query: to.query,
      //       })
      //     },
      //   }),
      // },
    ],
  },

  {
    path: "/design-system",
    component: RouterView,
    children: designSystem,
  },

  // Catch-all route to display `NotFound` pages
  {
    path: "*",
    component: () => import("@/views/NotFound.vue"),
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

function getTitle(title) {
  return title ? `${title} | ${config.appName}` : config.appName
}

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"]
  const isFacebookConnected = store.getters["auth/isFacebookConnected"]
  const isAdAccountConnected = store.getters["accounts/isAdAccountConnected"]
  const hasValidSubscription = store.getters["auth/hasValidSubscription"]
  store.commit("app/SET_VIDEO_TUTORIAL", null)
  if (
    !isAuthenticated &&
    to.matched.some(r => r.meta.requiresAuth) &&
    !["Login", "Register"].includes(to.name ?? "")
  ) {
    return next("/login")
  }

  if (isAuthenticated) {
    if (
      !isFacebookConnected &&
      ["OnboardConnectFacebook"].indexOf(to.name) < 0
    ) {
      return next("/onboard/connect/facebook")
    }

    if (
      isFacebookConnected &&
      !isAdAccountConnected &&
      ["OnboardConnectBusinessManager", "OnboardConnectAdAccount"].indexOf(
        to.name
      ) < 0
    ) {
      return next("/onboard/connect/business-manager")
    }

    if (
      isFacebookConnected &&
      isAdAccountConnected &&
      !hasValidSubscription &&
      to.name !== "OnboardSubscription"
    ) {
      return next("/onboard/subscription")
    }

    if (["Login", "Register"].indexOf(to.name) >= 0) {
      return next("/dashboard")
    }
  }

  document.title = getTitle(to.meta.title ?? null)

  return next()
})

export default router
